import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import TrustBadgesSection from './components/TrustBadgesSection';
import StatsSection from './components/StatsSection';
// Services section removed per user request
import ComparisonSection from './components/ComparisonSection';
import RiskSection from './components/RiskSection';
import WhyNeedSection from './components/WhyNeedSection';
import CTASection from './components/CTASection';
import HowWeWorkSection from './components/HowWeWorkSection';
import PricingSection from './components/PricingSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import BlogSection from './components/BlogSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import ContactFormDialog from './components/ContactFormDialog';
import { Toaster } from './components/ui/toaster';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import BlogPost from './pages/BlogPost';

function HomePage() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const openForm = () => setIsContactFormOpen(true);
  return (
    <div className="bg-[#FAFAFA]">
      <Header onOpenContactForm={openForm} />
      <HeroBanner />
      <TrustBadgesSection />
      <StatsSection />
      <ComparisonSection />
      <RiskSection onOpenContactForm={openForm} />
      <WhyNeedSection onOpenContactForm={openForm} />
      <HowWeWorkSection />
      <CTASection onOpenContactForm={openForm}
        heading="Your Competitors Are Filing Right Now"
        paragraph="Every day without federal protection is another day your brand name is available for someone else to claim. Our team files within 5-7 business days."
        buttonText="Begin Your Filing" />
      <PricingSection onOpenContactForm={openForm} />
      <WhyChooseUsSection onOpenContactForm={openForm} />
      <BenefitsSection />
      <TestimonialsSection />
      <BlogSection />
      <FAQSection />
      <ContactSection onOpenContactForm={openForm} />
      <Footer onOpenContactForm={openForm} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
